// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    css: css`
            width: auto;
            margin:0;
        `,
};
promotionCodeFormStyles.applySuccessText = {
    color: "success",
};
promotionCodeFormStyles.gridContainer = { gap: 12 };
promotionCodeFormStyles.promotionCodeGridItem = {
    width: 12,
};
promotionCodeFormStyles.applyPromotionGridItem = {
    width: 12,
    css: css`
            width: 100%;
            display: flex;
        `,
};
promotionCodeFormStyles.removeCodeTag = {};
promotionCodeFormStyles.promotionCodeTextField = {
    labelProps: {
        transform: "none",
    }
};
